import fp from "lodash/fp";
import {
	creditHistoryConstants, preAppConstants
} from 'store';

var initialState = {
	loading: false,
	error: null,
	banks: [],
};

export const getCreditHistoryState = state => state.creditHistory;

// prettier-ignore
const selector = property =>
	fp.flow(getCreditHistoryState, fp.property(property));

export const getBanks = selector("banks");

export function creditHistory(state = initialState, action) {
	switch (action.type) {
		case preAppConstants.RESET_APPLICATION_STATE:
			return {
				...initialState,
			};
		case creditHistoryConstants.SET_BANKS:
			return fp.set("banks", action.banks, state);
		case creditHistoryConstants.SEND_CREDIT_HISTORY_REQUEST:
			return {
				...state,
				loading: true,
			};
		case creditHistoryConstants.SEND_CREDIT_HISTORY_SUCCESS:
			return {
				...state,
				loading: false,
			};
		case creditHistoryConstants.SEND_CREDIT_HISTORY_ERROR:
			return {
				...state,
				error: action.error,
				loading: false,
			};
		default:
			return state;
	}
}
